import { render, staticRenderFns } from "./ReportesSMSPantalla.vue?vue&type=template&id=85f835a0&scoped=true&"
import script from "./ReportesSMSPantalla.vue?vue&type=script&lang=ts&"
export * from "./ReportesSMSPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f835a0",
  null
  
)

export default component.exports